import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDining, DiningState } from "./diningModal";
import {
  ActiveInactiveDining,
  createDining,
  deleteDining,
  DiningImageUpload,
  getAllDining,
  getDiningByID,
  updateDining,
  deleteDiningImage,
} from "./services/dining.service";

const initialState: DiningState = {
  loading: false,
  formLoading: false,
  error: null,
  DiningList: [],
  DiningDetail: null,
  DiningID: null,
  DiningImageID: null,
};

const diningSlice = createSlice({
  name: "dining",
  initialState,
  reducers: {
    clearDiningDetails: (state) => {
      state.DiningDetail = null;
    },
    setDiningID: (state, action: PayloadAction<number | null>) => {
      state.DiningID = action.payload;
    },
    clearDiningID: (state) => {
      state.DiningID = null;
    },
    setDiningImageID: (state, action: PayloadAction<number | null>) => {
      state.DiningImageID = action.payload;
    },
    clearDiningImageID: (state) => {
      state.DiningImageID = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllDining.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      getAllDining.fulfilled,
      (state, action: PayloadAction<IDining[]>) => {
        state.loading = false;
        state.DiningList = action.payload || [];
      },
    );
    builder.addCase(getAllDining.rejected, (state, action) => {
      state.loading = false;
      state.error = (action.payload as any)?.message || "Something went wrong";
    });

    builder.addCase(createDining.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(createDining.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createDining.rejected, (state) => {
      state.formLoading = false;
    });

    builder.addCase(updateDining.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(updateDining.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateDining.rejected, (state) => {
      state.formLoading = false;
    });

    builder.addCase(getDiningByID.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(
      getDiningByID.fulfilled,
      (state, action: PayloadAction<IDining>) => {
        state.formLoading = false;
        state.DiningDetail = action.payload;
      },
    );
    builder.addCase(getDiningByID.rejected, (state) => {
      state.formLoading = false;
    });

    builder.addCase(deleteDining.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteDining.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteDining.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(ActiveInactiveDining.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(ActiveInactiveDining.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveDining.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(DiningImageUpload.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(DiningImageUpload.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(DiningImageUpload.rejected, (state) => {
      state.formLoading = false;
    });

    builder.addCase(deleteDiningImage.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(deleteDiningImage.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(deleteDiningImage.rejected, (state) => {
      state.formLoading = false;
    });
  },
});

export const { clearDiningDetails, setDiningID, clearDiningID, setDiningImageID, clearDiningImageID } =
  diningSlice.actions;
export default diningSlice.reducer;
